import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './BlogPost.css';
import BlogTemplate from '../components/common/BlogTemplate';

class BlogPost extends Component {
  render() {
    return (
      <BlogTemplate {...this.props}>
        <h1>
          Blockchain Traceability – Combating counterfeiting and parallel trading
        </h1>
        <h2>
          Traceability is the ability to trace something and verify the history, location and
          application of an item. It links the flow of information to physical products. Within
          the wider food and beverage sector traceability is vitally important for food safety
          and operational efficiency and the ability to extend traceability across the complete
          supply chain is being demanded more by consumers and regulators.
        </h2>
        <p>
          So, what of the whisky industry, how important is traceability when there are only
          three ingredients to worry about, water, barley and yeast. As with most producers of
          premium products, whisky producers strive for the highest quality assurance standards
          and efficient inventory control. Effective traceability systems have a positive impact
          on both. However, today’s whisky consumers are demanding more transparency and a
          greater appreciation of a brands provenance. They want to know more about what’s
          in the bottle they have purchased, and they want to know that what they are drinking
          is the real thing.
        </p>
        <p>
          The world is awash with counterfeit goods and unfortunately, for consumers and producers,
          the whisky industry is not immune to fake rip-offs. When one bottle of whisky can fetch
          over £800,00 at auction, as it did recently when Bonham’s in Edinburgh sold a bottle
          of The Macallan 1926 60-year-old, with a label by Valerio Adami, for £848,750, the
          incentive to fake the masterpieces, has never been greater.
        </p>
        <p>
          However, it is not just premium single malts that can be a target for the
          counterfeiters, often with fatal consequences. In Russia in 2015, more than 30 people
          died having consumed fake Jack Daniels. Given the potential financial, safety and health
          consequences of counterfeit whisky, the drive for transparency and provenance and the
          need for complete traceability has never been greater.
        </p>
        <div className="footnote">
          <p>
            To learn how Distilled ID can provide the traceability and authentication that
            supports your provenance while improving brand security and combating
            counterfeiting and parallel trading,
                <Link to="/contact"> contact us</Link>.
          </p>
        </div>
      </BlogTemplate >
    );
  }
}

export default BlogPost;



// WEBPACK FOOTER //
// ./src/blogposts/traceabilityBlog.js